export const DefaultStyleAttrs = {
  mx: 30,
  borderRadius: 16,

  responsiveMx: { sm: 20, md: 60 },
};
